import type { IUserInfo } from "@/hooks/use-user-info";
import httpClient from ".";
import { API_ENDPOINTS } from "./endpoints";
import type { IUiLabelsPayload } from "@/model/ui-labels";

export const fetchUiLabels = async (userInfo: IUserInfo) => {
  const payload: IUiLabelsPayload = {
    groupId: userInfo.groupId,
  };
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${userInfo?.accessToken}`,
    },
  };

  return httpClient
    .post(API_ENDPOINTS.UI_LABELS, payload, config)
    .then((response) => response.data);
};
